<div *ngIf="data">
    <div mat-dialog-title class="title">
        <span class="heading">{{ data.title }}</span>
        <button *ngIf="data.dialogType != 'critical'" (click)="cancel()" class="close-button" mat-icon-button matSuffix>
            <mat-icon class="close-icon-color">cancel</mat-icon>
        </button>
    </div>
    <div mat-dialog-content class="content">
        {{ data.message }}
    </div>

    <div class="dialog-body">
        <form [formGroup]="confirmForm">
            @if (accountsStage){
            <mat-label>You have to reverse the entry of this transaction in Actionstep.</mat-label>

            <div class="actionstep-url">
                <div class="link-wrapper">
                    <a [href]="actionstepMatterUrl"
                       target="_blank"
                       rel="noopener noreferrer">
                        Open Matter in Actionstep ({{ matterNo }})
                    </a>
                    <button mat-icon-button
                            class="small-copy-btn"
                            [cdkCopyToClipboard]="actionstepMatterUrl"
                            (cdkCopyToClipboardCopied)="onUrlCopied()"
                            matTooltip="Copy link to clipboard"
                            matTooltipPosition="below">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>
                <div class="warning-box">
                    You must be logged into Actionstep under the same jurisdiction.
                </div>
            </div>

            <mat-form-field class="fullLength">
                <mat-label>Have you reversed the transaction from Actionstep?</mat-label>
                <mat-select #isTransactionReversedSelect="matSelect" formControlName="isTransactionReversed">
                    <mat-option [value]="'Yes'">Yes</mat-option>
                    <mat-option [value]="'No'">No</mat-option>
                </mat-select>

                @if (confirmForm.get('isTransactionReversed')?.touched && confirmForm.get('isTransactionReversed')?.hasError('required')) {
                <mat-error>Please select Yes or No.</mat-error>
                }
            </mat-form-field>

            @if(confirmForm.get('isTransactionReversed')?.value === 'No'){
            <mat-label>You have to reverse this transaction manually from Actionstep.</mat-label>
            }
            }

            <mat-dialog-actions [ngSwitch]="data.buttonType" class="action-buttons">
                <ng-container *ngSwitchCase="'OkOnly'">
                    <button mat-raised-button (click)="confirm()" color="accent" [disabled]="accountsStage ? confirmForm.get('isTransactionReversed')?.value !== 'Yes': false">{{ data.confirmText }}</button>
                </ng-container>
                <ng-container *ngSwitchCase="'cancelOnly'">
                    <button mat-raised-button (click)="confirm()" color="warn" [disabled]="accountsStage ? confirmForm.get('isTransactionReversed')?.value !== 'Yes': false">{{ data.confirmText }}</button>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <button mat-raised-button (click)="confirm()" color="accent" [disabled]="accountsStage ? confirmForm.get('isTransactionReversed')?.value !== 'Yes': false">{{ data.confirmText }}</button>
                    <button mat-raised-button (click)="cancel()" color="warn">{{ data.cancelText }}</button>
                </ng-container>
            </mat-dialog-actions>
        </form>
    </div>
</div>
